import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { FormField } from '@/models';
import { makeFormField } from '@/helpers';
import { countries } from '@/constants';

interface EditCountryForm {
  [key: string]: FormField;
}

@Component({
  name: 'CmgEditCountryModal',
})
export default class CmgEditCountryModal extends Vue {
  form: EditCountryForm = {
      country: makeFormField(),
    };
  isLoading = false;
  isFormValid = true;

  @Watch('visible', { immediate: true})
  visibleChanged(visible: boolean) {
    if (visible) {
      this.initializeForm();
    }
  }
  
  get visible(): boolean {
    return this.$appStore.state.ui.modals.editCountryModal.visible;
  }

  getCountryFlagUrl(countryCode: string): string {
    return this.$appStore.state.cms.images.countryFlags[countryCode.toLowerCase()].default;
  }

  get countryProfiles(): object[] {
    return Object.values(countries);
  }

  onSelectCountry(value: string): void {
    this.form.country.error = '';
    this.form.country.dirty = true;
    this.form.country.value = value;
  }

  initializeForm(): void {
    this.isFormValid = true;
    this.form.country.value = this.$appStore.state.ui.countryProfile.countryCode;
  }

  async onUpdateCountry(): Promise<void> {
    await this.$services.restaurant.selectRestaurant(null, true);
    await this.$services.order.setDeliveryAddress(null);
    this.$services.order.resetPendingOrder();

    const redirectQueryParams: { [key: string]: string } = {};
    const customer = this.$appStore.state.customer;
    redirectQueryParams.loggedIn = customer && customer.jwt && customer.profile && !customer.profile.isGuest ? 'true' : 'false';

    this.$services.ui.setCountryProfile(countries[this.form.country.value.toLowerCase()], true, redirectQueryParams);
    this.onClose();
    this.isLoading = false;
  }

  onClose() {
    this.initializeForm();
    this.$services.ui.setModalVisibility('editCountryModal', false);
    this.$services.ui.focusBack();
  }
}
